// api.ts
import axios from "axios";

let onUnauthorized: (() => void) | null = null;

export const setUnauthorizedHandler = (handler: () => void) => {
    onUnauthorized = handler;
};


const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL_CONEKTAPP,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && onUnauthorized) {
            onUnauthorized(); // 👈 dispara el confirm de sesión caducada
        }
        return Promise.reject(error);
    }
);

// Cliente Axios dedicado para Devsmart-AI API
export const devsmartApi = axios.create({
    baseURL: import.meta.env.VITE_API_URL_DEVSMART_AI || import.meta.env.VITE_API_URL_CONEKTAPP,
    headers: {
        "Content-Type": "application/json",
    },
});

devsmartApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

